export const entries = [
	{
		'type': 'repository',
		'title': 'Bracelets tracker',
		'singular': 'Bracelets tracker item',
		'parentId': null,
		'rank': 1,
		'id': 's1enm2V9M3b2c5kYyd4XU',
		'fakeId': 's1enm2V9M3b2c5kYyd4XU',
		'isBookmarked': true,
		'color': '#FF6B6B'
	},
	{
		'type': 'templatePropertyDate',
		'label': 'Date',
		'slug': 'date',
		'required': true,
		'parentId': 's1enm2V9M3b2c5kYyd4XU',
		'rank': 1,
		'id': 'Rcci9_XYvgRDspCzBpz5V',
		'fakeId': 'Rcci9_XYvgRDspCzBpz5V'
	},
	{
		'type': 'templatePropertyNumber',
		'label': 'Number of bracelets completed',
		'slug': 'completed',
		'required': true,
		'parentId': 's1enm2V9M3b2c5kYyd4XU',
		'rank': 1,
		'id': 'Lj_z3QPUBow6hkaBP39IM',
		'fakeId': 'Lj_z3QPUBow6hkaBP39IM'
	},
	{
		'type': 'chart',
		'parentId': null,
		'repositoryId': 's1enm2V9M3b2c5kYyd4XU',
		'rank': 1,
		'title': 'Bracelets progress',
		'where': '{"date":{"end":"2026-10-31"}}',
		'includeArchived': true,
		'metric': 'completed',
		'xAxis': 'date',
		'xAxisTimeScale': 'W',
		'targetA': 0,
		'targetB': 150,
		'xy': {
			'x': -7.145942106879403,
			'y': -21.361841600122744
		},
		'id': 'CJGT0x_bh6qQe2Zp6776m',
		'fakeId': 'CJGT0x_bh6qQe2Zp6776m',
		'variant': 'line'
	},
	{
		'type': 'note',
		'title': 'I am working on a creative project and I want to make 150 bracelets by the end of October',
		'parentId': null,
		'rank': 1,
		'xy': {
			'x': -6.048398720840424,
			'y': -164.35828042302307
		},
		'id': 'YEeI0GQeMHbdD9na7vJWk',
		'fakeId': 'YEeI0GQeMHbdD9na7vJWk',
		'variant': 'default'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 's1enm2V9M3b2c5kYyd4XU',
		'repositoryId': 's1enm2V9M3b2c5kYyd4XU',
		'id': 'Ws6nicnKNvNfKyCk_wTX-',
		'fakeId': 'Ws6nicnKNvNfKyCk_wTX-',
		'rank': 'Zx'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 's1enm2V9M3b2c5kYyd4XU',
		'propertyDefinitionId': 'Rcci9_XYvgRDspCzBpz5V',
		'slug': 'date',
		'parentId': 'Ws6nicnKNvNfKyCk_wTX-',
		'value': '2026-05-15',
		'id': 'KS40jUhrEKJ5_9K_iGJyg',
		'fakeId': 'KS40jUhrEKJ5_9K_iGJyg'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 's1enm2V9M3b2c5kYyd4XU',
		'propertyDefinitionId': 'Lj_z3QPUBow6hkaBP39IM',
		'slug': 'completed',
		'parentId': 'Ws6nicnKNvNfKyCk_wTX-',
		'value': 10,
		'id': 'cz2qSbyUv72PGcGP7Q5bW',
		'fakeId': 'cz2qSbyUv72PGcGP7Q5bW'
	},
	{
		'type': 'repositoryEntry',
		'parentId': 's1enm2V9M3b2c5kYyd4XU',
		'repositoryId': 's1enm2V9M3b2c5kYyd4XU',
		'id': 'oXjAC3_-0vYjsBjAx62vx',
		'fakeId': 'oXjAC3_-0vYjsBjAx62vx',
		'rank': 'Zy'
	},
	{
		'type': 'entryPropertyDate',
		'repositoryId': 's1enm2V9M3b2c5kYyd4XU',
		'propertyDefinitionId': 'Rcci9_XYvgRDspCzBpz5V',
		'slug': 'date',
		'parentId': 'oXjAC3_-0vYjsBjAx62vx',
		'value': '2026-05-08',
		'id': 'biw5lpadat_G5d-biSF_y',
		'fakeId': 'biw5lpadat_G5d-biSF_y'
	},
	{
		'type': 'entryPropertyNumber',
		'repositoryId': 's1enm2V9M3b2c5kYyd4XU',
		'propertyDefinitionId': 'Lj_z3QPUBow6hkaBP39IM',
		'slug': 'completed',
		'parentId': 'oXjAC3_-0vYjsBjAx62vx',
		'value': 5,
		'id': 'fl47M-qtAYhmGskgplDZ0',
		'fakeId': 'fl47M-qtAYhmGskgplDZ0'
	},
	{
		'type': 'note',
		'title': 'Keep adding new entries to the Bracelets tracker collection each week as you go, and see your progress on the chart :)',
		'parentId': null,
		'rank': 2,
		'xy': {
			'x': 47.60639871026592,
			'y': 197.71475974324144
		},
		'id': 'wnqfgGxnj4SV7ExWr4Yob',
		'fakeId': 'wnqfgGxnj4SV7ExWr4Yob',
		'variant': 'default'
	}
];